import { FloatingChatForm } from "./floating-chat-form";
import { bindFloatingChatScroll } from "./floating-chat-listener";
import { bindFloatingChatModalVisibility } from "./floating-chat-modal-visibility";

export function setupFloatingChat(): void {
    const button = new FloatingChatForm().getFloatingButton();
    if (!button) return;

    bindFloatingChatScroll(button);
    bindFloatingChatModalVisibility(button);
}
